/**
 * Outbound-Klick-Tracking auf allen Seiten → GA4 (G-7K43Z5K2D8) über das
 * gtag der Google-&-YouTube-App. Event „outbound_click“ mit link_url,
 * link_domain, link_text, link_type (link | whatsapp | email | phone).
 * Consent: läuft über dasselbe gtag, hält also den Consent Mode der App ein.
 * Datenschutz: bei mailto:/tel: keine Adresse/Nummer senden; URLs ohne Query.
 * Capture-Phase, weil manche Links (Partner im Konfigurator) stopPropagation
 * aufrufen.
 */
(function () {
  if (window.AS51OutboundInit) return;
  window.AS51OutboundInit = true;

  var OWN_HOST = /(^|\.)area-s51\.de$|(^|\.)myshopify\.com$/i;
  var WHATSAPP_HOST = /(^|\.)wa\.me$|(^|\.)whatsapp\.com$/i;

  function linkText(a) {
    var text = a.innerText || a.getAttribute('aria-label') || a.getAttribute('title') || '';
    if (!text) {
      var img = a.querySelector('img[alt]');
      if (img) text = img.getAttribute('alt');
    }
    return String(text).replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  function onClick(ev) {
    if (ev.type === 'auxclick' && ev.button !== 1) return;
    if (typeof window.gtag !== 'function') return;
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var url;
    try {
      url = new URL(a.href, window.location.href);
    } catch (e) {
      return;
    }
    var type;
    var linkUrl;
    var domain;
    if (url.protocol === 'mailto:') {
      type = 'email';
      linkUrl = 'mailto:';
      domain = 'email';
    } else if (url.protocol === 'tel:') {
      type = 'phone';
      linkUrl = 'tel:';
      domain = 'phone';
    } else if (url.protocol === 'http:' || url.protocol === 'https:') {
      if (OWN_HOST.test(url.hostname)) return;
      type = WHATSAPP_HOST.test(url.hostname) ? 'whatsapp' : 'link';
      linkUrl = url.origin + url.pathname;
      domain = url.hostname.replace(/^www\./, '');
    } else {
      return;
    }
    try {
      window.gtag('event', 'outbound_click', {
        link_url: linkUrl,
        link_domain: domain,
        link_text: linkText(a),
        link_type: type,
        outbound: true,
        transport_type: 'beacon'
      });
    } catch (e) {
      /* fail-open */
    }
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
})();
